module.exports = __webpack_public_path__ + "img/asw-logo.b9da6899.png";